<template>
  <div>
    <v-layout wrap v-if="!hideMain">
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('name') }}</label>
        <input
          type="text"
          :placeholder="$t('name')"
          v-model.lazy="filter.fullname"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Channel') }}</label>
        <multiselect
          v-model="filter.app"
          :options="channelOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('gender') }}</label>
        <multiselect
          v-model="filter.gender"
          :options="genderOptions"
          label="label"
          selectLabel
          selectedLabel
          :allow-empty="false"
          :searchable="false"
          deselect-label
          track-by="label"
        ></multiselect>
      </v-flex>
      <v-flex xs12 sm3 class="form-control pa-1">
        <label for>{{ $t('Locale') }}</label>
        <multiselect
          v-model="filter.locale"
          :options="localeOptions"
          label="title"
          selectLabel
          selectedLabel
          deselect-label
          track-by="value"
          :multiple="true"
          :placeholder="$t('Locale')"
        >
          <template slot="option" slot-scope="props">
            <flag :iso="props.option.icon" />

            {{ props.option.title }}
          </template>
        </multiselect>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('First Conversation at') }}</label>
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.registerDate.start"
                @selected="onRegisterStartDate"
                :placeholder="$t('from')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.registerDate.end"
                style
                @selected="onRegisterEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
      <v-flex xs12 sm6 class="form-control pa-1">
        <div>
          <label for>{{ $t('Last Conversation at') }}</label>
        </div>
        <template>
          <v-layout>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.activeDate.start"
                @selected="onActiveStartDate"
                :placeholder="$t('from')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
            <v-flex class="pa-1">
              <datepicker
                v-model="filter.activeDate.end"
                style
                @selected="onActiveEndDate"
                :placeholder="$t('to')"
                :clear-button="true"
                :clear-button-icon="'fas fa-times'"
              ></datepicker>
            </v-flex>
          </v-layout>
        </template>
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Email') }}</label>
        <input
          type="text"
          :placeholder="$t('Email')"
          v-model.lazy="filter.email"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('phone no.') }}</label>
        <input
          type="text"
          placeholder="Phone No"
          v-model.lazy="filter.phoneno"
          class="form-control"
          maxlength="255"
        />
      </v-flex>
      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>Message Symbol</label>
        <v-radio-group v-model="filter.messagesent.symbol" row style="margin-top: 5px;">
          <v-radio
            :label="$t('Greater than')"
            :value="{ value: 'g__', label: $t('Greater than')}"
            color="primary"
          ></v-radio>
          <v-radio
            :label="$t('Less than')"
            :value="{value: 'l__',  label: $t('Less than')}"
            color="primary"
          ></v-radio>
        </v-radio-group>
      </v-flex>-->
      <!-- <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label for>{{$t('Message Sent')}}</label>
        <div
          class="form-inline form-control"
          :class="{'has-error': errors.has('filterMessageSentFrom') || errors.has('filterMessageSent')}"
        >
          <input
            type="text"
            class="form-control"
            name="filterMessageSent"
            data-vv-name="filterMessageSent"
            :data-vv-as="$t('Message Sent')"
            :placeholder="$t('Message Sent')"
            v-model="filter.messagesent.value"
            v-validate="'numeric'"
          />

          <p
            class="text-error"
            v-if="errors.has('filterMessageSentFrom')"
          >{{ errors.first('filterMessageSentFrom') }}</p>
          <p
            class="text-error"
            v-else-if="errors.has('filterMessageSent')"
          >{{ errors.first('filterMessageSent') }}</p>
        </div>
      </v-flex>-->

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('LINEID') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('filterLineId') }">
          <input
            type="text"
            class="form-control"
            name="filterLineId"
            data-vv-name="filterLineId"
            :data-vv-as="$t('LINEID')"
            :placeholder="$t('LINEID')"
            v-model.lazy="filter.lineid"
          />

          <p class="text-error" v-if="errors.has('filterLineId')">
            {{ errors.first('filterLineId') }}
          </p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('School') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('School') }">
          <multiselect
            v-model="filter.school"
            :options="allSchools"
            :options-limit="10"
            :loading="isLoading"
            @search-change="asyncFindSchools"
            placeholder="Select one"
            label="name"
            track-by="name"
          ></multiselect>
          <p class="text-error" v-if="errors.has('School')">{{ errors.first('School') }}</p>
        </div>
      </v-flex>

      <v-flex v-if="isBU" xs12 sm6 md3 class="form-control pa-1">
        <label for>{{ $t('Province') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Province') }">
          <input
            type="text"
            class="form-control"
            name="Province"
            data-vv-name="Province"
            :data-vv-as="$t('Province')"
            :placeholder="$t('Province')"
            v-model.lazy="filter.province"
          />
          <p class="text-error" v-if="errors.has('Province')">
            {{ errors.first('Province') }}
          </p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Context') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Context')"
            :placeholder="$t('Context')"
            v-model.lazy="filter.context"
          />

          <p class="text-error" v-if="errors.has('Context')">{{ errors.first('Context') }}</p>
        </div>
      </v-flex>

      <v-flex xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Customer Types') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <multiselect
            v-model="filter.specialcondition"
            :options="specialconditionOptions"
            :searchable="false"
            label="label"
            track-by="value"
            selectLabel
            selectedLabel
            deselect-label
            :placeholder="$t('Conversation')"
          ></multiselect>

          <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>
      <v-flex v-if="selectedBot.theme == 'sahapan'" xs12 sm6 md3 class="form-control pa-1">
        <label>{{ $t('Realname') }}</label>
        <div class="form-inline form-control" :class="{ 'has-error': errors.has('Context') }">
          <input
            type="text"
            class="form-control"
            name="Context"
            data-vv-name="Context"
            :data-vv-as="$t('Real name')"
            :placeholder="$t('Real name')"
            v-model="filter.realname"
          />

          <p class="text-error" v-if="errors.has('Province')">{{ errors.first('Province') }}</p>
        </div>
      </v-flex>
      <!-- <v-flex xs12 class="form-control pa-1">
        <label for>{{$t('Conversation')}}</label>
        <multiselect
          v-model="filter.intent"
          :options="filterIntent"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :placeholder="$t('Conversation')"
        ></multiselect>
      </v-flex>-->

      <v-flex xs12 class="form-control pa-1" :class="{ 'has-error': errorFilterTag.length > 0 }">
        <label for>{{ $t('Tag') }}</label>
        <tags
          v-model="tag"
          :tags="tags"
          @tags-changed="addTags"
          @before-adding-tag="checkTag"
          style="margin-bottom: 10px"
          :btnText="$t('Add tag')"
          :isDrag="false"
        ></tags>

        <span class="text-error" v-if="errorFilterTag.length > 0">
          <template v-if="errorFilterTag.includes('overmaxlength')">{{
            $t('Message cannot be longer than 20 alphabets')
          }}</template>
          <template v-else-if="errorFilterTag.includes('duplicate')">{{
            $t('Duplicate Tag')
          }}</template>
        </span>
      </v-flex>
      <v-flex xs12 class="form-control pa-1">
        <label for>{{ $t('Status') }}</label>
        <v-radio-group color="primary" v-model="filter.statustype" row class="text-xs-center">
          <v-radio color="primary" :label="$t('Includes')" :value="'includes'"></v-radio>
          <v-radio color="primary" :label="$t('Excludes')" :value="'excludes'"></v-radio>
        </v-radio-group>
        <multiselect
          v-model="filter.status"
          :options="userStatus"
          :searchable="true"
          selectLabel
          selectedLabel
          deselect-label
          :multiple="true"
          :placeholder="$t('Status')"
          @select="$emit('onChangeStatus')"
          @remove="$emit('onChangeStatus')"
        ></multiselect>
      </v-flex>
    </v-layout>
    <slot name="append" :filter="filter"></slot>
    <div class="text-xs-right pa-1">
      <slot></slot>
      <!-- <v-flex xs12 class="pa-1 mt-1">
        <div
          style="text-align: right; color: black; font-size: 1.1em"
        >{{$t('Total')}}: {{total_user}}</div>
      </v-flex>-->
    </div>
  </div>
</template>

<script>
import api from '@/api'
import config from '@/config'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import datepicker from 'vuejs-datepicker'
import Tags from '@/components/elements/Tags'

export default {
  props: {
    value: {
      default: undefined,
    },
    hideMain: {
      default: false,
    },
  },
  components: {
    Multiselect,
    datepicker,
    Tags,
  },
  mounted: function () {
    this.getIntent()
    //this.$emit('onUpdate')
  },
  data: function () {
    return {
      allSchools: [],
      isLoading: false,
      filter: this.value,
      channelOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Facebook'),
          value: 'facebook',
        },
        {
          label: this.$t('Line'),
          value: 'line',
        },
      ],
      genderOptions: [
        {
          label: this.$t('All'),
          value: 'all',
        },
        {
          label: this.$t('Male'),
          value: 'male',
        },
        {
          label: this.$t('Female'),
          value: 'female',
        },
        {
          label: this.$t('no gender'),
          value: 'other',
        },
      ],
      specialconditionOptions: [
        {
          label: this.$t('Active Users'),
          value: 'activeusers',
        },
        {
          label: this.$t('Potential Users'),
          value: 'potentialusers',
        },
        {
          label: this.$t('Purchased Users'),
          value: 'perchasedusers',
        },
        {
          label: this.$t('Loyal Customer'),
          value: 'perchasedusers_royalty',
        },
        {
          label: this.$t('New Customer'),
          value: 'perchasedusers_newcomer',
        },
      ],
      localeOptions: config.locale,
      symbolOptions: [
        {
          value: 'g__',
          label: this.$t('Greater than'),
        },
        {
          value: 'l__',
          label: this.$t('Less than'),
        },
        {
          value: 'n__',
          label: this.$t('Not'),
        },
      ],
      intents: [],
      errorFilterTag: [],
      tag: '',
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      userStatus: 'getUserStatus',
      loadingUserStatus: 'getLoadingUserStatus',
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function () {
      var vm = this
      vm.intents.sort(function (a, b) {
        var nameA = a.intentname.toUpperCase() // ignore upper and lowercase
        var nameB = b.intentname.toUpperCase() // ignore upper and lowercase
        if (a.intentname[0] == '{' && a.intentname[a.intentname.length - 1] == '}') {
          return 1
        }
        if (b.intentname[0] == '{' && b.intentname[b.intentname.length - 1] == '}') {
          return -1
        }
        if (nameA < nameB) {
          return -1
        }
        if (nameA > nameB) {
          return 1
        }

        // names must be equal
        return 0
      })
      var intents = []
      $.each(vm.intents, function (index, intent) {
        intents.push(intent.intentname)
      })
      return intents
    },
    tags: {
      get() {
        let vm = this
        if (vm.filter && vm.filter.tags && vm.filter.tags !== '') {
          var tags = []
          tags = vm.filter.tags.split(',')
          var result = []
          if (tags) {
            tags.map(function (tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function (tag, index) {
            result.push(tag.text)
          })
        }
        vm.filter.tags = result.join(',')
      },
    },
  },
  methods: {
    asyncFindSchools(data) {
      let vm = this
      if (!vm.allSchools.length && !vm.isLoading) {
        vm.isLoading = true
        api.getschoollist(data, function (error, response) {
          if (error) {
            console.error(error)
          } else {
            vm.allSchools = response.data
            vm.isLoading = false
          }
        })
      }
    },
    checkTag(obj) {
      this.errorFilterTag = []
      if (obj.tag.text.length > 9999) {
        this.errorFilterTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorFilterTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    addTags: function (newTags) {
      this.tags = newTags
    },
    getIntent: function (callback) {
      let vm = this
      let auth = null
      return new Promise((resolve, reject) => {
        let data = {
          pageid: vm.selectedBot.pageid,
        }
        if (vm.selectedBot.theme == 'universalutilities') {
          if (vm.selectedBot.uu_areaname) {
            data.intentgroup = vm.selectedBot.uu_areaname
          }
        }
        api.getIntent(data, function (error, response) {
          if (error) {
            console.error(error)
            reject(error)
          }
          if (response.data) {
            var isFoundDefault = false
            var intents = []
            $.each(response.data, function (index, val) {
              var intent = val
              intent.isShow = false
              intents.push(intent)
            })
            vm.intents = intents
          }
          resolve()
        })
      })
    },
    onActiveStartDate: function (value) {
      var vm = this
      if (moment(this.filter.activeDate.end).isBefore(value)) {
        this.filter.activeDate.end = value
      }
      this.filter.activeDate.start = value
      this.$emit('onUpdate')
    },
    onActiveEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.activeDate.start)) {
        this.filter.activeDate.start = value
      }
      this.filter.activeDate.end = value
      this.$emit('onUpdate')
    },
    onRegisterStartDate: function (value) {
      var vm = this
      if (moment(this.filter.registerDate.end).isBefore(value)) {
        this.filter.registerDate.end = value
      }
      this.filter.registerDate.start = value
      this.$emit('onUpdate')
    },
    onRegisterEndDate: function (value) {
      var vm = this
      if (moment(value).isBefore(this.filter.registerDate.start)) {
        this.filter.registerDate.start = value
      }
      this.filter.registerDate.end = value
      this.$emit('onUpdate')
    },
  },
  watch: {
    value: function (newVal) {
      this.filter = newVal
    },
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/elements/FilterCustomer.vue